import { ref, type Ref } from 'vue'
import type { HblIUseCms } from '@/utils/types'
import type { CmsSection} from '@hubblecommerce/hubble/platforms/shopware/api-client';
import { ContentShopware } from '@hubblecommerce/hubble/platforms/shopware/api-client'

const cmsData: Ref<any> = ref(null)
const loading: Ref<any> = ref(false)
const error: Ref<string> = ref('')

export function useCms (): HblIUseCms {
    async function fetchCms (id: any): Promise<void> {
        loading.value = true;

        try {
            loading.value = true
            const response = await ContentShopware.readCms(id)
            if (response?.sections == null) {
                loading.value = false
                return
            }

            cmsData.value = hblMapSections(response?.sections as unknown as CmsSection[])
        } catch (e) {
            console.error(e);
            error.value = 'Failed to fetch cms data';
        } finally {
            loading.value = false
        }
    }


    return {
        cmsData,
        fetchCms
    }
}
